module.exports = __webpack_public_path__ + "img/stick_divers_transports.95aa963c.svg";